<template>
  <div class="title">
    <div class="title__text">
      <span class="title__text-date">{{ date }}</span>
      <span class="title__text-author">{{ author }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    author: {
      type: String,
      default: null,
    },
    date: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.title {
  position: relative;
  margin-bottom: 1.5rem;

  &__text {
    font-size: 1.2rem;

    &-date {
      font-weight: 100;
      color: #383838;
    }

    &-author {
      font-weight: 400;
      color: #003d6a;
      display: inline-block;
      margin-left: 2rem;
    }
  }
}
</style>
